import React from 'react';
import { type WidgetCommonProps } from '../../types';
import { BackgroundInspector } from './background-inspector';
import { FillInspector } from './fill-inspector';
import { GlowInspector } from './glow-inspector';
import { ShadowInspector } from './shadow-inspector';
import { StrokeInspector } from './stroke-inspector';
import './style.less';

type Props = WidgetCommonProps & {
    onOpenSubPanel: (subPanel: string, type?: string) => void;
};

const TextEffectController = (props: Props) => {
    return (
        <div className="text-effect-fast-operate">
            <FillInspector {...props} />
            <StrokeInspector {...props} />
            <ShadowInspector {...props} />
            <GlowInspector {...props} />
            <BackgroundInspector {...props} />
        </div>
    );
};

export default React.memo(TextEffectController);
